import { sagaEffects } from '../../dependencies';

import fetchDisposableExport from './fetchDisposableExport';

const { all } = sagaEffects;

export default function*() {
    yield all([fetchDisposableExport()]);
}
